import { explorers } from '../../types/executor';
export const getTxnResults = (swapResult) => {
    try {
        const addExplorerUrl = (input) => {
            return input === null || input === void 0 ? void 0 : input.map((x) => {
                if (Array.isArray(x)) {
                    //Jito Solana
                    return x
                        .map((y) => {
                        const network = y === null || y === void 0 ? void 0 : y.network;
                        const hash = y === null || y === void 0 ? void 0 : y.hash;
                        if (!y || !network || !hash)
                            return null;
                        return Object.assign(Object.assign({}, y), { explorerUrl: `${explorers[network]}${hash}` });
                    })
                        .filter((x) => x);
                }
                else {
                    //Normal
                    const network = x === null || x === void 0 ? void 0 : x.network;
                    const hash = x === null || x === void 0 ? void 0 : x.hash;
                    if (!x || !network || !hash)
                        return null;
                    return Object.assign(Object.assign({}, x), { explorerUrl: `${explorers[network]}${hash}` });
                }
            }).filter((x) => x);
        };
        const decodedResponse = swapResult === null || swapResult === void 0 ? void 0 : swapResult.decodedResponse;
        //@ts-ignore
        const inputSponsors = addExplorerUrl(
        //@ts-ignore
        (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransactions)
            ? Array.isArray(decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransactions)
                ? decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransactions
                : [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransactions]
            : //@ts-ignore
                [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sponsorTransaction].filter((x) => x));
        //@ts-ignore
        const inputApprovals = addExplorerUrl(
        //@ts-ignore
        decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.approvalTransactions);
        const inputSwaps = addExplorerUrl(
        //@ts-ignore
        (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sourceEVMTransactions) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sourceSolanaTransactions) ||
            //@ts-ignore
            ((decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.solanaSwapTransaction)
                ? //@ts-ignore
                    [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.solanaSwapTransaction]
                : false) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.swapTransactions) || [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.swapTransaction]);
        const outputSwaps = addExplorerUrl(
        //@ts-ignore
        (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.destinationEVMTransactions) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.crossChainOutputSwapTransactions) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.destinationSolanaTransactions));
        //@ts-ignore
        console.log('lsgowrhg', inputSponsors, inputApprovals, inputSwaps, outputSwaps, decodedResponse, 
        //@ts-ignore
        (decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sourceEVMTransactions) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.sourceSolanaTransactions) ||
            //@ts-ignore
            ((decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.solanaSwapTransaction)
                ? //@ts-ignore
                    [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.solanaSwapTransaction]
                : false) ||
            (
            //@ts-ignore
            decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.swapTransactions) || [decodedResponse === null || decodedResponse === void 0 ? void 0 : decodedResponse.swapTransaction]);
        //@ts-ignore
        return { inputSponsors, inputApprovals, inputSwaps, outputSwaps };
    }
    catch (e) {
        console.log('getTxnResultsError', e);
        return {
            inputSponsors: [],
            inputApprovals: [],
            inputSwaps: [],
            outputSwaps: [],
        };
    }
};
